import { StoreProductModel } from "./products/store-product.model";

export class MonthlyOrderModel {
  date: Date;
  days: number;
  orders: string;
  inStock: string;
  buyBox: string;
  listings: StoreProductModel[];
  selected: boolean;
  leftSelected: boolean;
}